import { Typography } from '@mui/material';
import { MultiLineChartTooltipProps } from '@shared/models/charts/multi-line-chart.model.ts';

const MultiLineChartTooltip = ({
  active,
  payload,
  label,
  lines,
  tooltipValueFormatter,
  tooltipLabelFormatter
}: MultiLineChartTooltipProps) => {
  if (!active || !payload || !payload.length) return null;

  const formattedLabel =
    tooltipLabelFormatter && label ? tooltipLabelFormatter(label) : label;

  return (
    <div
      className="bg-(--white) rounded-lg px-3 py-2"
      style={{ boxShadow: '0 4px 12px var(--black-alpha-150)' }}
    >
      <div className="text-base text-(--dark-2) mb-2">{formattedLabel}</div>
      {lines.map((line) => {
        const entry = payload.find((p) => p.dataKey === String(line.dataKey));
        if (!entry) return null;
        const value = entry.value as number;
        const formatted = tooltipValueFormatter
          ? tooltipValueFormatter(value)
          : value;
        return (
          <div
            key={String(line.dataKey)}
            className="flex items-center gap-2 mb-2 last:mb-0"
          >
            <div
              className="w-2.5 h-2.5 rounded-full shrink-0"
              style={{ backgroundColor: line.color }}
            />

            <Typography variant="body2" className="text-(--blue-4)!">
              {line.label}: {formatted}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default MultiLineChartTooltip;
